import { Button, Paper, useTheme } from "@mui/material";

interface SubmitButtonProps {
  isUpdate: boolean;
  disabled: boolean;
  isDrawer?: boolean;
  submitLabel: string;
  updateLabel: string;
  onClick: () => void;
}

const SubmitButton = ({
  isUpdate,
  disabled,
  isDrawer = false,
  submitLabel,
  updateLabel,
  onClick,
}: SubmitButtonProps) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        right: 0,
        bottom: 0,
        width: "100%",
        position: "fixed",
        backgroundColor: "transparent",
        [theme.breakpoints.down('sm')]: {
          left: 0,
          width: "100%",
        },
        [theme.breakpoints.up('md')]: {
          left: !isDrawer ? theme.mixins.sidebar.width : "auto",
          width: !isDrawer ? `calc(100% - ${theme.mixins.sidebar.width}px)` : "400px",
        },
        borderRadius: 0,
        zIndex: theme.zIndex.drawer - 1,
        padding: 2,
      }}
      elevation={0}
    >
      <Button
        fullWidth
        type="submit"
        variant="contained"
        disabled={disabled}
        color="primary"
        size="large"
        onClick={onClick}
      >
        {isUpdate ? updateLabel : submitLabel}
      </Button>
    </Paper>
  );
};

export default SubmitButton;
